// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --gq-brand: var(--fc-brand, #5ea1d8);
  --gq-text: #000000;
  --gq-muted: #666666;
  --gq-border: #e0e0e0;
  --gq-surface: #ffffff;
  --gq-soft: #f7fafd;
  display: block;
  font-family: "Raleway", sans-serif;
}

:host-context(body.theme-dark) {
  --gq-text: #e2e8f0;
  --gq-muted: #94a3b8;
  --gq-border: rgba(148, 163, 184, 0.25);
  --gq-surface: #111827;
  --gq-soft: #0f172a;
}

.gqe {
  margin: 20px 0 8px;
  padding: 16px;
  border: 1px solid var(--gq-border);
  border-radius: 8px;
  background: var(--gq-surface);
}
.gqe--on {
  background: var(--gq-soft);
}

.gqe__head {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.gqe__label {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  color: var(--gq-text);
}

.gqe__hint {
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 1.4;
  color: var(--gq-muted);
}

.gqe__body {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.gqe__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  -moz-column-gap: 16px;
       column-gap: 16px;
}

.gqe__grow {
  flex: 1 1 240px;
  min-width: 0;
}

.gqe__full {
  width: 100%;
}

.gqe__type {
  flex: 0 1 220px;
}

.gqe__mode {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: 20px;
}
.gqe__mode mat-radio-group {
  display: flex;
  gap: 8px;
}

.gqe__sublabel {
  font-size: 14px;
  font-weight: 500;
  color: var(--gq-text);
}

.gqe__required {
  padding-bottom: 20px;
}

.gqe__question {
  padding: 12px 16px 8px;
  border: 1px solid var(--gq-border);
  border-radius: 8px;
  background: var(--gq-surface);
}

.gqe__question-head {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
}
.gqe__question-head button[mat-icon-button] {
  color: var(--gq-muted);
}

.gqe__qnum {
  font-size: 15px;
  font-weight: 600;
  color: var(--gq-brand);
}

.gqe__spacer {
  flex: 1 1 auto;
}

.gqe__options {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 8px;
}
.gqe__options .gqe__sublabel {
  margin-bottom: 4px;
}

.gqe__option {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gqe__option button[mat-icon-button] {
  color: var(--gq-muted);
}

/* Option inputs sit in a list, so drop the space Material reserves for hints. */
.gqe__option-field ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.gqe__option-field {
  margin: 4px 0;
}

.gqe__bullet {
  color: #9e9e9e;
  flex: 0 0 auto;
  margin: 0 10px;
}

.gqe__option-fixed {
  flex: 1 1 auto;
  padding: 12px 0;
  font-size: 15px;
  color: var(--gq-text);
}

.gqe__btn {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 7px 20px;
  border: 1px solid var(--gq-brand);
  border-radius: 25px;
  background: #ffffff;
  color: var(--gq-brand);
  font-family: "Raleway", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s, color 0.3s;
}
.gqe__btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.gqe__btn:hover:not(:disabled) {
  background: var(--gq-brand);
  color: #ffffff;
}
.gqe__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.gqe__btn--small {
  padding: 4px 14px;
  font-size: 13px;
  margin-left: 40px;
}

:host-context(body.theme-dark) .gqe__btn {
  background: transparent;
}

.gqe__footer {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.gqe__count {
  font-size: 13px;
  color: var(--gq-muted);
}

.gqe__errors {
  margin: 0;
  padding: 10px 14px 10px 30px;
  border-radius: 8px;
  background: #ffebee;
  color: #b71c1c;
  font-size: 13px;
  line-height: 1.5;
}

:host-context(body.theme-dark) .gqe__errors {
  background: rgba(127, 29, 29, 0.35);
  color: #fecaca;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/guide-questions/guide-question-form-editor.component.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,kCAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,sCAAA;EACA,qBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,kCAAA;EACA,kBAAA;EACA,6BAAA;AACF;AACE;EACE,0BAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAAF;;AAGA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;OAAA,gBAAA;AAAF;;AAGA;EACE,eAAA;EACA,YAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,oBAAA;AAAF;AAEE;EACE,aAAA;EACA,QAAA;AAAJ;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;AADF;;AAIA;EACE,oBAAA;AADF;;AAIA;EACE,sBAAA;EACA,kCAAA;EACA,kBAAA;EACA,6BAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AADF;AAGE;EACE,sBAAA;AADJ;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AAFF;AAIE;EACE,kBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAHF;AAKE;EACE,sBAAA;AAHJ;;AAOA,gFAAA;AACA;EACE,aAAA;AAJF;;AAOA;EACE,aAAA;AAJF;;AAOA;EACE,cAAA;EACA,cAAA;EACA,cAAA;AAJF;;AAOA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;AAJF;;AAOA;EACE,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,iCAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;AAJF;AAME;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAJJ;AAOE;EACE,2BAAA;EACA,cAAA;AALJ;AAQE;EACE,YAAA;EACA,mBAAA;AANJ;AASE;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;AAPJ;;AAWA;EACE,uBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AARF;;AAWA;EACE,eAAA;EACA,sBAAA;AARF;;AAWA;EACE,SAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AARF;;AAWA;EACE,mCAAA;EACA,cAAA;AARF","sourcesContent":[":host {\n  --gq-brand: var(--fc-brand, #5ea1d8);\n  --gq-text: #000000;\n  --gq-muted: #666666;\n  --gq-border: #e0e0e0;\n  --gq-surface: #ffffff;\n  --gq-soft: #f7fafd;\n  display: block;\n  font-family: \"Raleway\", sans-serif;\n}\n\n:host-context(body.theme-dark) {\n  --gq-text: #e2e8f0;\n  --gq-muted: #94a3b8;\n  --gq-border: rgba(148, 163, 184, 0.25);\n  --gq-surface: #111827;\n  --gq-soft: #0f172a;\n}\n\n.gqe {\n  margin: 20px 0 8px;\n  padding: 16px;\n  border: 1px solid var(--gq-border);\n  border-radius: 8px;\n  background: var(--gq-surface);\n\n  &--on {\n    background: var(--gq-soft);\n  }\n}\n\n.gqe__head {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.gqe__label {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.5;\n  color: var(--gq-text);\n}\n\n.gqe__hint {\n  margin: 4px 0 0;\n  font-size: 13px;\n  line-height: 1.4;\n  color: var(--gq-muted);\n}\n\n.gqe__body {\n  margin-top: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.gqe__row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  column-gap: 16px;\n}\n\n.gqe__grow {\n  flex: 1 1 240px;\n  min-width: 0;\n}\n\n.gqe__full {\n  width: 100%;\n}\n\n.gqe__type {\n  flex: 0 1 220px;\n}\n\n.gqe__mode {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding-bottom: 20px;\n\n  mat-radio-group {\n    display: flex;\n    gap: 8px;\n  }\n}\n\n.gqe__sublabel {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--gq-text);\n}\n\n.gqe__required {\n  padding-bottom: 20px;\n}\n\n.gqe__question {\n  padding: 12px 16px 8px;\n  border: 1px solid var(--gq-border);\n  border-radius: 8px;\n  background: var(--gq-surface);\n}\n\n.gqe__question-head {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 8px;\n\n  button[mat-icon-button] {\n    color: var(--gq-muted);\n  }\n}\n\n.gqe__qnum {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--gq-brand);\n}\n\n.gqe__spacer {\n  flex: 1 1 auto;\n}\n\n.gqe__options {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 8px;\n\n  .gqe__sublabel {\n    margin-bottom: 4px;\n  }\n}\n\n.gqe__option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  button[mat-icon-button] {\n    color: var(--gq-muted);\n  }\n}\n\n/* Option inputs sit in a list, so drop the space Material reserves for hints. */\n.gqe__option-field ::ng-deep .mat-mdc-form-field-subscript-wrapper {\n  display: none;\n}\n\n.gqe__option-field {\n  margin: 4px 0;\n}\n\n.gqe__bullet {\n  color: #9e9e9e;\n  flex: 0 0 auto;\n  margin: 0 10px;\n}\n\n.gqe__option-fixed {\n  flex: 1 1 auto;\n  padding: 12px 0;\n  font-size: 15px;\n  color: var(--gq-text);\n}\n\n.gqe__btn {\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 7px 20px;\n  border: 1px solid var(--gq-brand);\n  border-radius: 25px;\n  background: #ffffff;\n  color: var(--gq-brand);\n  font-family: \"Raleway\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.3s, color 0.3s;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  &:hover:not(:disabled) {\n    background: var(--gq-brand);\n    color: #ffffff;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &--small {\n    padding: 4px 14px;\n    font-size: 13px;\n    margin-left: 40px;\n  }\n}\n\n:host-context(body.theme-dark) .gqe__btn {\n  background: transparent;\n}\n\n.gqe__footer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.gqe__count {\n  font-size: 13px;\n  color: var(--gq-muted);\n}\n\n.gqe__errors {\n  margin: 0;\n  padding: 10px 14px 10px 30px;\n  border-radius: 8px;\n  background: #ffebee;\n  color: #b71c1c;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n:host-context(body.theme-dark) .gqe__errors {\n  background: rgba(127, 29, 29, 0.35);\n  color: #fecaca;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
